<template>

	<div class="controls">
		<div>	
			<i class="fal fa-circle-notch fa-spin fa-fw" v-if="loading"></i>
		</div>
		<div>	
			<div class="switch round tiny">
				<input type="checkbox" :name="setting" :id="setting" v-model="status" v-on:click="toggleSetting">
				<label :for="setting" class="right inline">{{label}} </label>
			</div>
		</div>

	</div>
</template>


<script>
'use strict';
	export default {
		name: 'Toggle',
		data() {
			return {
				status: '',
				loading: true
			}
		},

		props: {
			setting: {
				required: false,
				type: String,
				default: function() {
					return this.$root.$el.dataset.settingName
				}

			},
			label : {
				required: false,
				type: String,
				default: function() {
					return this.$root.$el.dataset.settingLabel
				}
			}
		},

		methods: {

			async getSetting() {
				try {


					this.loading = true;
					const url = Routing.generate('ApiBundle_get_setting', {setting: this.setting});
					const request = new Request(url, {
						method: 'GET',
						credentials: 'same-origin'
					});

					const setting = await fetch(request);
					const settingJson = await setting.json();
					this.loading = false;
					this.status = !!parseInt(settingJson.data);
				} catch(error) {
					console.error(error);
				}

			},

			async toggleSetting() {
				try {
					
					this.loading = true;
					const url = Routing.generate('ApiBundle_toggle_setting', {setting: this.setting});
					const request = new Request(url, {
						method: 'POST',
						credentials: 'same-origin'
					});
					
					const statusRequest = await fetch(request);
					const statusJson = await statusRequest.json();
					this.loading = false;
					this.status = !!parseInt(statusJson.data);
					this.$emit('toggle-setting', {setting: this.setting, status: this.status});
				} catch(error) {
					console.error(error);
				}


			}

		
		},

		computed: {
			booleanStatus() {
				if(this.status == 1) {
					return true;
				} else {
					return false;
				}
			}
		
		},

		components: {

		},

		beforeMount() {
		},

		mounted() {
			this.getSetting();
		},
		created() {

		}

	};
</script>


<style scoped>

[v-cloak] {
	display: none;
}

.grid-row {
	display: grid;
	grid-template-columns: 8fr 4fr;
	align-items: center;
}

.controls {
	display: grid;
	grid-template-columns: 1fr 1fr;
}
	
</style>